module.exports = "<div class=prism-player id=J_prismPlayer></div>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-players/nn-player-brightcove/nn-player-brightcove-new.directive.html
// module id = 1042
// module chunks = 0